import React from 'react'



import 'font-awesome/css/font-awesome.min.css';

import Navlist from './Navlist';
function Header(){
   return (
   <div>
       <header className="header-wrapper">
         <div className="internal-wrapper">
           
           <div className="header-links-wrapper">
             
             <ul>
             <div className="social-media-icons">
     <a href="https://www.facebook.com/profile.php?id=100010846481936" target="_blank" rel="noopener noreferrer">
         <i className="fa fa-facebook"></i>
     </a>
     <a href="https://t.me/@mesfin9090" target="_blank" rel="noopener noreferrer">
         <i className="fa fa-telegram"></i>
     </a>
     <a href="https://www.linkedin.com/in/mesfin-desale-b8654b248/" target="_blank" rel="noopener noreferrer">
         <i className="fa fa-linkedin"></i>
     </a>
 </div>
             
   <Navlist LinkUrl="/" LinkName="Home"/>
   <Navlist LinkUrl="/" LinkName="Service"/>

   <Navlist LinkUrl="https://mesfin-1.web.app/" LinkName="Portfolio"/>
   <Navlist LinkUrl="https://github.com/messfind" LinkName="Projects"/>
                           <Navlist LinkUrl="https://t.me/@mesfin9090" LinkName="Contact us" />
                       </ul>
                    </div>
                </div>
            </header>
   </div> 
   )
}

export default Header;